import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _046fe29c = () => interopDefault(import('../pages/datenschutz.vue' /* webpackChunkName: "pages/datenschutz" */))
const _20d27430 = () => interopDefault(import('../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _3f53ccf2 = () => interopDefault(import('../pages/wissen.vue' /* webpackChunkName: "pages/wissen" */))
const _5eb05090 = () => interopDefault(import('../pages/l/federweisser.vue' /* webpackChunkName: "pages/l/federweisser" */))
const _c7857926 = () => interopDefault(import('../pages/l/lage.vue' /* webpackChunkName: "pages/l/lage" */))
const _2c36981d = () => interopDefault(import('../pages/l/nacht-der-guten-weine.vue' /* webpackChunkName: "pages/l/nacht-der-guten-weine" */))
const _dd18bc2e = () => interopDefault(import('../pages/l/neue-weine/index.vue' /* webpackChunkName: "pages/l/neue-weine/index" */))
const _72d415be = () => interopDefault(import('../pages/l/prima-probier-paket.vue' /* webpackChunkName: "pages/l/prima-probier-paket" */))
const _7935d9d6 = () => interopDefault(import('../pages/l/veranstaltungen.vue' /* webpackChunkName: "pages/l/veranstaltungen" */))
const _726c92bc = () => interopDefault(import('../pages/l/wein-des-monats/index.vue' /* webpackChunkName: "pages/l/wein-des-monats/index" */))
const _25a6dad9 = () => interopDefault(import('../pages/l/willkommen.vue' /* webpackChunkName: "pages/l/willkommen" */))
const _cbbd3b04 = () => interopDefault(import('../pages/l/wissen-federweisser.vue' /* webpackChunkName: "pages/l/wissen-federweisser" */))
const _50a8032c = () => interopDefault(import('../pages/l/wissen-restzucker-sekt.vue' /* webpackChunkName: "pages/l/wissen-restzucker-sekt" */))
const _27230f38 = () => interopDefault(import('../pages/l/wissen-restzucker-wein.vue' /* webpackChunkName: "pages/l/wissen-restzucker-wein" */))
const _7e5c75c2 = () => interopDefault(import('../pages/l/wissen-so-macht-man-das-murmeln.vue' /* webpackChunkName: "pages/l/wissen-so-macht-man-das-murmeln" */))
const _44cf10a8 = () => interopDefault(import('../pages/l/wissen-spargel-wein.vue' /* webpackChunkName: "pages/l/wissen-spargel-wein" */))
const _6694ca64 = () => interopDefault(import('../pages/l/neue-weine/_slug/index.vue' /* webpackChunkName: "pages/l/neue-weine/_slug/index" */))
const _0b269f46 = () => interopDefault(import('../pages/l/wein-des-monats/_slug/index.vue' /* webpackChunkName: "pages/l/wein-des-monats/_slug/index" */))
const _39201f8b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/datenschutz",
    component: _046fe29c,
    name: "datenschutz"
  }, {
    path: "/impressum",
    component: _20d27430,
    name: "impressum"
  }, {
    path: "/wissen",
    component: _3f53ccf2,
    name: "wissen"
  }, {
    path: "/l/federweisser",
    component: _5eb05090,
    name: "l-federweisser"
  }, {
    path: "/l/lage",
    component: _c7857926,
    name: "l-lage"
  }, {
    path: "/l/nacht-der-guten-weine",
    component: _2c36981d,
    name: "l-nacht-der-guten-weine"
  }, {
    path: "/l/neue-weine",
    component: _dd18bc2e,
    name: "l-neue-weine"
  }, {
    path: "/l/prima-probier-paket",
    component: _72d415be,
    name: "l-prima-probier-paket"
  }, {
    path: "/l/veranstaltungen",
    component: _7935d9d6,
    name: "l-veranstaltungen"
  }, {
    path: "/l/wein-des-monats",
    component: _726c92bc,
    name: "l-wein-des-monats"
  }, {
    path: "/l/willkommen",
    component: _25a6dad9,
    name: "l-willkommen"
  }, {
    path: "/l/wissen-federweisser",
    component: _cbbd3b04,
    name: "l-wissen-federweisser"
  }, {
    path: "/l/wissen-restzucker-sekt",
    component: _50a8032c,
    name: "l-wissen-restzucker-sekt"
  }, {
    path: "/l/wissen-restzucker-wein",
    component: _27230f38,
    name: "l-wissen-restzucker-wein"
  }, {
    path: "/l/wissen-so-macht-man-das-murmeln",
    component: _7e5c75c2,
    name: "l-wissen-so-macht-man-das-murmeln"
  }, {
    path: "/l/wissen-spargel-wein",
    component: _44cf10a8,
    name: "l-wissen-spargel-wein"
  }, {
    path: "/l/neue-weine/:slug",
    component: _6694ca64,
    name: "l-neue-weine-slug"
  }, {
    path: "/l/wein-des-monats/:slug",
    component: _0b269f46,
    name: "l-wein-des-monats-slug"
  }, {
    path: "/",
    component: _39201f8b,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
